import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {DcpApiService, HttpRequestOptions, TransactionList} from '@dcp/configurator';
import {Observable} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {DcpKymaService} from './dcp-kyma.service';

@Injectable({
  providedIn: 'root',
})
export class DcpTransactionService {
  constructor(private http: HttpClient, private kymaService: DcpKymaService, private dcpApiService: DcpApiService) {}

  getTransactions(userId: string = ''): Observable<TransactionList> {
    return this.kymaService
      .prepareAuthConfig()
      .pipe(
        concatMap((config: HttpRequestOptions) =>
          this.http.post<TransactionList>(`${this.kymaService.getUrl('transaction')}/${userId}`, {}, config)
        )
      );
  }

  getCtaForContractAndProduct(contractId: string, product: string): Observable<TransactionList> {
    const options: HttpRequestOptions = new HttpRequestOptions();
    options.body = {contracts: [{contractId, product}]};
    return this.dcpApiService.callKyma<TransactionList>('transaction', '', {}, options, 'POST');
  }
}
